/* CIEPLUCHOWO core JS */
(function () {
  'use strict';
  if (window.__cpCore) return; window.__cpCore = true;
  if ('IntersectionObserver' in window) document.documentElement.classList.add('cp-js');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = root.querySelectorAll('.cp-reveal:not([data-cp-rv])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute('data-cp-rv', '1'); io.observe(el); });
  }

  function initFaq(root) {
    root.querySelectorAll('.cp-faq__item:not([data-cp-faq])').forEach(function (item) {
      item.setAttribute('data-cp-faq', '1');
      var btn = item.querySelector('.cp-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wrap = item.closest('.cp-section') || root;
        var open = item.classList.contains('is-active');
        wrap.querySelectorAll('.cp-faq__item.is-active').forEach(function (o) { o.classList.remove('is-active'); var q = o.querySelector('.cp-faq__q'); if (q) q.setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  function initRail(root) {
    root.querySelectorAll('.cp-rail:not([data-cp-rail])').forEach(function (wrap) {
      wrap.setAttribute('data-cp-rail', '1');
      var track = wrap.querySelector('.cp-rail__track');
      if (!track) return;
      function step() { var c = track.querySelector(':scope > *'); return c ? c.getBoundingClientRect().width + 20 : 300; }
      var prev = wrap.querySelector('[data-cp-prev]'), next = wrap.querySelector('[data-cp-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    });
  }

  /* Zaznacz styl w głównym formularzu produktu (swatch Shrine) */
  function norm(v) { return String(v || '').trim().toLocaleUpperCase('pl-PL'); }
  function selectStyle(value) {
    var want = norm(value), done = false;
    document.querySelectorAll('.product__info-container variant-selects input[type="radio"], .product__info-container .product-form__input input[type="radio"]').forEach(function (inp) {
      if (done) return;
      if (norm(inp.value) === want) {
        if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        done = true;
      }
    });
    return done;
  }
  window.cpSelectStyle = selectStyle;

  function initPreselect() {
    try {
      var p = new URLSearchParams(window.location.search).get('styl');
      if (p) setTimeout(function () { selectStyle(p); }, 50);
    } catch (e) {}
  }

  /* QUIZ: 3 pytania → styl z największą liczbą głosów */
  function initQuiz(root) {
    root.querySelectorAll('[data-cp-quiz]:not([data-cp-qz])').forEach(function (quiz) {
      quiz.setAttribute('data-cp-qz', '1');
      var steps = [].slice.call(quiz.querySelectorAll('.cp-quiz__step'));
      var results = [].slice.call(quiz.querySelectorAll('.cp-quiz__res'));
      var bars = [].slice.call(quiz.querySelectorAll('.cp-quiz__bar i'));
      var answers = [];
      function show(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        results.forEach(function (r) { r.classList.remove('is-active'); });
        bars.forEach(function (b, k) { b.classList.toggle('is-on', k <= i); });
      }
      function finish() {
        var count = {}, order = [];
        answers.forEach(function (a) { if (!(a in count)) { count[a] = 0; order.push(a); } count[a] += 1; });
        var best = order[0];
        order.forEach(function (k) { if (count[k] > count[best]) best = k; });
        if (answers.length && count[best] === 1) best = answers[answers.length - 1];
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        bars.forEach(function (b) { b.classList.add('is-on'); });
        var hit = results.filter(function (r) { return norm(r.getAttribute('data-result')) === norm(best); })[0] || results[0];
        if (hit) hit.classList.add('is-active');
        quiz.setAttribute('data-picked', best || '');
      }
      steps.forEach(function (step, i) {
        step.querySelectorAll('.cp-quiz__opt').forEach(function (opt) {
          opt.addEventListener('click', function () {
            step.querySelectorAll('.cp-quiz__opt').forEach(function (o) { o.classList.remove('is-picked'); });
            opt.classList.add('is-picked');
            answers[i] = opt.getAttribute('data-style');
            answers.length = i + 1;
            setTimeout(function () { i + 1 < steps.length ? show(i + 1) : finish(); }, reduced ? 0 : 220);
          });
        });
        var back = step.querySelector('[data-cp-back]');
        if (back) back.addEventListener('click', function () { show(Math.max(0, i - 1)); });
      });
      quiz.querySelectorAll('[data-cp-again]').forEach(function (b) { b.addEventListener('click', function () { answers = []; quiz.querySelectorAll('.is-picked').forEach(function (o) { o.classList.remove('is-picked'); }); show(0); }); });
      quiz.querySelectorAll('[data-cp-pick]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (selectStyle(a.getAttribute('data-cp-pick'))) {
            e.preventDefault();
            var target = document.querySelector('.product__info-container variant-selects') || document.querySelector('.product__info-container');
            if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          }
        });
      });
    });
  }

  function initAll(scope) { var r = scope || document; initReveal(r); initFaq(r); initRail(r); initQuiz(r); }
  function boot() { initAll(document); initPreselect(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
